import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/Painting.jpg";
import {FaPaintRoller} from "react-icons/fa";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function PaintingPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Painting Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Discover expert painting services in Charlotte NC. From interior to exterior, our skilled team delivers quality paint jobs for your home renovation needs."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><FaPaintRoller className={classes.servicesIcon}/> {languageContext.services.PaintingPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.PaintingPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.PaintingPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.PaintingPage.text2}</span>
                            <br/>
                            {languageContext.services.PaintingPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.PaintingPage.text4}</span>
                            <br/>
                            {languageContext.services.PaintingPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.PaintingPage.text6}</span>
                            <br/>
                            {languageContext.services.PaintingPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.PaintingPage.text8}</span>
                            <br/>
                            {languageContext.services.PaintingPage.text9}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.image}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default PaintingPage;